import { State } from '@/apps/appCreator/store';
import { createSelector } from '@reduxjs/toolkit';
import { TBrandCar } from './getBrandCar';

type TDisclaimersSortOrder = {
  [key: string]: number;
};

const disclaimerSortOrder: TDisclaimersSortOrder = {
  price: 1,
  tradein: 2,
  credit: 3,
  medical: 4,
  final: 5,
};

export enum Disclaimers {
  price = 'price',
  final = 'final',
  tradein = 'tradein',
  credit = 'credit',
  medical = 'medical',
}

export type TSortedDisclaimers = Map<string, TDisclaimerItem>;

export type TDisclaimerItem = {
  sortOrder?: number;
  value?: string;
};

const getCarDisclaimers = createSelector(
  (state: State) => state.vehicles,
  (state: State, brandCar: TBrandCar) => brandCar?.model,
  ({ vehicles }, brandCarModel: string) => {
    const sortedDisclaimers: TSortedDisclaimers = new Map();
    if (!vehicles || !brandCarModel) {
      return sortedDisclaimers;
    }

    const vehicle = vehicles.find(
      vehicle =>
        vehicle.modifications[0]?.name.toLowerCase() ==
        brandCarModel.toLowerCase()
    );

    const disclaimers = vehicle?.modifications[0]?.disclaimers || {};

    Object.keys(disclaimers)
      .sort((a, b) => {
        if (disclaimerSortOrder[a] && disclaimerSortOrder[b]) {
          return disclaimerSortOrder[a] - disclaimerSortOrder[b];
        }
        return 0;
      })
      .filter(disclaimer => disclaimers[disclaimer]?.length !== 0)
      .map((disclaimer, idx) => {
        const disclaimerItem = {
          sortOrder: idx + 1,
          value: disclaimers[disclaimer],
        };
        sortedDisclaimers.set(disclaimer, disclaimerItem);
      });

    return sortedDisclaimers;
  }
);

export default getCarDisclaimers;
